export const LANDING = '/';
// AUTH ROUTES
export const LOGIN = '/login';
export const SIGN_UP = '/sign-up';
export const RESET_PASSWORD = '/password/reset';
// APP ROUTES
export const HOME = '/';
export const ACCOUNT = '/account';
export const EDIT_PROFILE = '/account/edit-profile';
export const CHANGE_PASSWORD = '/account/change-password';
export const BECOME_ARTIST = '/account/become-artist';
export const APP = '/app';
export const QUEUE = '/queue';
export const PLAYLIST = '/playlist/:id';

export const SEARCH = '/search';
export const PLAYLISTS = '/playlists';
export const ARTISTS = '/artists';
export const MY_LIKES = '/my-likes';
export const MY_UPLOADS = '/my-uploads';
export const POPULAR = '/popular';
export const UPLOAD_TRACK = '/upload-track';
export const MY_PLAYLISTS = '/my-playlists';

export const GENRE = '/genre/:id';
export const ARTIST = '/account/:id';
